<template>
	<div class="gift_promo">
		<!-- <a href class="flex" @click.prevent="toggle">
      <h4>Use an eGift card</h4>
      <div class="flex">
        <span
          v-if="
            order && order.RedeemedGiftCards && order.RedeemedGiftCards.length
          "
          class="badge"
          >{{ order.RedeemedGiftCards.length }}</span
        >
        <span class="chevron" :class="{ up: openForm }"></span>
      </div>
    </a> -->
		<!-- <transition name="slide-vertical"> -->
		<section class="_container">
			<form id="promo_form" class="flex" @submit.prevent="submitCode">
				<fieldset>
					<input
						type="text"
						placeholder="Enter eGift card number"
						v-model="giftcard.value"
					/>
				</fieldset>
				<button
					:disabled="giftcard.ajaxing || giftcard.value == ''"
					type="submit"
					class="blue"
					:class="{ button_loading: giftcard.ajaxing }"
				>
					Apply
				</button>
			</form>
			<transition name="slide-vertical">
				<p v-show="giftcard.error" class="flex_start error">
					<i class="material-icons mr-1">error</i>
					<span v-html="giftcard.error"></span>
				</p>
			</transition>
			<transition name="slide-vertical">
				<p
					v-if="promoMessage"
					class="bg-gray pl-2 pr-2 pt-1 pb-1 mb-1 border_radius flex_start"
					v-html="promoMessage"
				></p>
			</transition>
			<transition name="slide-vertical">
				<loader class="mb-1" v-if="removeLoading && order.OrderGiftCardCodes" />
			</transition>
			<div class="flex_start wrap_tags">
				<span
					v-for="gc in order.RedeemedGiftCards"
					class="promo_tag"
					:key="gc.OrderMerchandiseGiftCardKey"
				>
					<div class="flex">
						<span
							>{{ gc.GiftCardCode ? gc.GiftCardCode : 'missing GiftCardCode' }}
							{{ currency_symbol }}{{ gc.Amount }}</span
						>
						<span>
							<button
								:disabled="removeLoading"
								class="close_button"
								@click.prevent="unDoCode(gc.OrderMerchandiseGiftCardKey)"
							></button>
						</span>
					</div>
				</span>
			</div>
		</section>
		<!-- </transition> -->
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { gzip } from 'node-gzip';
	import Loader from './Loader.vue';
	import currencySymbol from '@/mixins/currencySymbol';
	export default {
		name: 'GiftPromo',
		//props: ["type"],
		mixins: [currencySymbol],
		data() {
			return {
				openForm: false,
				promoMessage: false,
				removeLoading: false,
				giftcard: {
					value: '',
					ajaxing: false,
					error: false,
				},
			};
		},
		computed: {
			...mapState(['order']),
		},
		components: {
			Loader,
		},
		methods: {
			toggle() {
				this.openForm = this.openForm ? false : true;
			},
			submitCode: async function() {
				this.PromoError = false;
				//this.PromoApplied = false;

				const data = {
					ClientLocationKey: this.$route.params.client,
					OrderKey: this.$store.state.order.OrderKey,
					GiftCardCode: this.giftcard.value,
				};

				if (this.giftcard.value) {
					this.$set(this.giftcard, 'ajaxing', true);
					this.$set(this.giftcard, 'error', false);

					this.promoMessage = false;

					// eslint-disable-next-line no-undef
					$.ajax({
						type: 'POST',
						url: this.$store.state.serverPath + '/redeemgiftcard',
						contentType: 'application/json',
						data: await gzip(JSON.stringify(data)).then((z) => {
							return z;
						}),
						processData: false,
						headers: {
							'Content-Encoding': 'gzip',
						},
						cache: false,
						success: (json) => {
							this.$set(this.giftcard, 'ajaxing', false);
							this.$set(this.giftcard, 'value', '');

							if (json.Applied === false) {
								this.$set(this.giftcard, 'error', json.Message);
							}
							//
							else {
								//if(json.Order && json.Order.OrderKey){
								this.$store.commit('updateOrder', json.Order);
								//}

								this.promoMessage = json.Message;
							}

							// this.loading = false;
							// this.$store.commit("updatePromoMessage", json.Message);
							// if (json.Applied == false) {
							//   this.PromoError = true;
							//   this.PromoApplied = false;
							// } //
							// else {
							//   this.PromoApplied = true;
							//   this.$store.commit("updateOrder", json.Order);
							// }
							//
							// setTimeout(() => {
							//   this.$emit("resetCartHeight", {});
							// }, 100);
							// this.$store.commit("hideLoader");
						}, //success

						error: (msg) => {
							console.warn(msg);
							this.$set(this.giftcard, 'ajaxing', false);
						},

						done: function() {
							//this.$store.commit("hideLoader");
							//this.loading = false;
						},
					}); // ajax
				}
				//
				else {
					console.warn('No promo code entered.');
					this.PromoError = true;
				}
			}, // submitCode

			unDoCode: async function(orderGiftCardCodeKey) {
				this.PromoError = false;
				//this.PromoApplied = false;
				this.removeLoading = true;

				this.promoMessage = false;

				this.$set(this.giftcard, 'value', '');
				this.$set(this.giftcard, 'error', false);

				const data = {
					ClientLocationKey: this.$route.params.client,
					OrderKey: this.order.OrderKey,
					OrderMerchandiseGiftCardKey: orderGiftCardCodeKey, //this.promo.OrderGiftCardCodeKey
				};

				// eslint-disable-next-line no-undef
				$.ajax({
					type: 'POST',
					url: this.$store.state.serverPath + '/UnRedeemGiftcard',
					contentType: 'application/json',
					data: await gzip(JSON.stringify(data)).then((z) => {
						return z;
					}),
					processData: false,
					headers: {
						'Content-Encoding': 'gzip',
					},
					cache: false,
					success: (json) => {
						//if (json.Order) {
						this.$store.commit('updateOrder', json.Order);
						//}

						this.removeLoading = false;
					}, //success

					error: (msg) => {
						this.removeLoading = false;
						console.warn(msg);
						//this.$store.commit("hideLoader");
					},
				}); // ajax
			}, // unDoCode
		},
	};
</script>

<style></style>
